import React from 'react'
import styled from 'styled-components'
import kissImg from '../../../images/kiss.gif'
import giphySDKCelebrateImg from '../../../images/giphysdk-promo.gif'
import apiImg from '../../../images/api.gif'
import { giphyLightBlue, giphyAqua } from '../../../styles/colors'
import GradientLink from '../../shared/gradient-link'
import Image from '../../image'

const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 75px;

    img {
        width: 100px;
    }

    p {
        margin-bottom: 0;
        font-size: 20px;
        line-height: 28px;
    }

    h1 {
        margin-bottom: 15px;
    }
`

const Products = styled.div`
    display: flex;
    margin: 0 auto;
    margin-bottom: 75px;
    padding: 0 10px;
`

const Product = styled.div`
    h3 {
        margin-bottom: 15px;
    }

    p {
        margin-bottom: 20px;
    }

    &:last-child {
        margin-left: 5px;
    }

    &:first-child {
        margin-right: 5px;
    }

    img {
        width: 100%;
        object-fit: cover;
        height: 300px;
        margin-bottom: 10px;
    }
`

const Endpoints = styled.div`
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: repeat(2, 300px);
    grid-gap: 0px;
`

type DirectionOptions = 'to bottom right' | 'to bottom left' | 'to top right'
type EndpointProps = {
    direction?: DirectionOptions
}
const Endpoint = styled.div<EndpointProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 45px;
    text-align: center;
    box-sizing: border-box;

    ${({ direction }) =>
        direction &&
        `
        border-image-source: linear-gradient(
            ${direction},
            #112239 55%,
            ${giphyLightBlue}7f,
            ${giphyAqua}7f 100%,
            transparent
        );
        border-image-slice: 1;
    `}
`

const EndpointHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-right: 25px;

    h3 {
        margin: 0 0 0 10px;
    }
`

const DevProducts = () => {
    const products = [
        {
            src: giphySDKCelebrateImg,
            header: 'GIPHY SDKs',
            text: `With GIPHY SDKs, there's no need to re-invent the wheel: if you use GIPHY in your website or application,
            our SDKs provide you with libraries that will have you implementing features faster than ever.`,
            url: '/docs/sdk',
        },
        {
            src: apiImg,
            header: 'GIPHY API',
            text: `GIPHY's API makes it dead simple for developers to incorporate GIPHY's vast library right inside of
            their apps. Use it across all types of apps: messaging, chat, dating, creation, community, and more!`,
            url: '/docs/api',
        },
    ]

    const endpoints = [
        {
            imgName: 'trending',
            width: 40,
            header: 'Trending',
            text: `The most relevant, engaging content each day directly in your app or website. Our feed of trending content is continuously updated, so you’re always in the loop.`,
            url: '/docs/api/endpoint#trending',
            direction: 'to bottom right',
            style: {
                borderWidth: '0 1px 1px 0',
                borderStyle: 'solid',
            },
        },
        {
            imgName: 'search',
            width: 40,
            header: 'Search',
            text: `Animate your conversation with our unparalleled search algorithm that lets users express themselves in a fraction of a second.`,
            url: '/docs/api/endpoint#search',
            direction: 'to bottom left',
            style: {
                borderBottom: '1px solid',
            },
        },
        {
            imgName: 'translate',
            width: 40,
            header: 'Translate',
            text: `If you have a word or phrase in mind, we'll use our special sauce algorithm to match it to the perfect GIF. (you may have used this feature on Slack!)`,
            url: '/docs/api/endpoint#translate',
            direction: 'to top right',
            style: {
                borderRight: '1px solid',
            },
        },
        {
            imgName: 'random',
            width: 45,
            header: 'Random',
            text: `Want to add some weirdness to the conversation? Use Random for a completely random GIF. For a little less randomness, give us a word and we’ll find something you like.`,
            url: '/docs/api/endpoint#random',
        },
    ]

    return (
        <section>
            <Header>
                <img src={kissImg} />
                <h1>Our Developer Products</h1>
                <p>All the tools for all the GIFs.</p>
            </Header>
            <Products>
                {products.map(({ src, header, text, url }, index) => (
                    <Product key={index}>
                        <img src={src} />
                        <h3>{header}</h3>
                        <p>{text}</p>
                        <GradientLink text={'Learn More'} url={url} />
                    </Product>
                ))}
            </Products>
            <Endpoints>
                {endpoints.map(({ imgName, header, text, url, width, direction, style }, index) => (
                    <Endpoint direction={direction as DirectionOptions} style={style} key={index}>
                        <EndpointHeader>
                            <Image imageName={imgName} width={width} />
                            <h3>{header}</h3>
                        </EndpointHeader>
                        <p>{text}</p>
                        <GradientLink text={'Learn More'} url={url} isCentered={true} />
                    </Endpoint>
                ))}
            </Endpoints>
        </section>
    )
}

export default DevProducts
